import {TransportCategory, transportMethods} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<TransportCategory>;

export const TransportMethodSelect = (props: Props) => {
  const {options = transportMethods, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
